import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Render } from '../../../../../../Components/CustomUi/render'
import {
  Capa,
  HeaderRelatorio,
  ResumoTesteBandeja,
  SubCapa,
  Sumario,
  Tratores,
  TrReverse,
} from '../../../styles'
import {
  dividirEmPaginasResumoSumario,
  mostrarEsconderGraficos,
  verificarCvCoresBackground,
  verificarCvCoresGraficos,
} from '../meta'
import { faLongArrowAltUp } from '@fortawesome/free-solid-svg-icons'
import { Switcher } from '../../../../../../Components/CustomUi/Switcher'
import Trator from '../../../../../../assets/img/trator.png'
import Logo from '../../../../../../assets/img/logo.png'
import { FixedSizeList as List } from 'react-window'
import React, { Fragment, useRef } from 'react'
import { uniqueId } from 'lodash'
import { Tag } from 'antd'
import { useAccess } from '../../../../../../context/useAccess'
import { Page } from '../../../../../../Components/ordemLaboratorio/mapaFertilidade/DrawerPrint/styles'
import { Box } from '../../../../../../Components/CustomUi/box'
import { PropsSugestoes } from '..'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import dayjs from 'dayjs'

type GrupoDados = {
  cod: number
  cv: string
  media: string
  largura: string
  sentido: number
  dados: {
    numero: number[]
    cor: string[]
  }
}

type Graficos = {
  cod: number
  grupo: GrupoDados[]
  grafico11: string
  grafico12: string
}

type calculo = {
  cod: number
  largura: string
  cv: string
  minima: string
  maxima: string
  media: string
  sentido: number
}

export type calculoResumo = {
  data: string
  calculo: calculo[]
}

interface PropsGraficos {
  renderizarGraficos: boolean
  esconderSwitch: boolean
  dadosFinalizados: Graficos[]
  graficoSelecionados: any[]
  graficosSelecionadosImprimir: Function
  gerando: boolean
  imprimirGraficos: boolean
  mostrarResumo: boolean
  mostrarGraficos: boolean
  mostrarSugestoes: boolean
  listar_resumo_teste: calculoResumo
  dadosSugestoes: PropsSugestoes[]
  todosSelecionados: boolean
  propriedade: string
  nome_equipamento: string
  realizado_por: string
  nome_consultor: string
}

export const Graficos: React.FC<PropsGraficos> = ({
  dadosFinalizados,
  renderizarGraficos,
  esconderSwitch,
  graficoSelecionados,
  graficosSelecionadosImprimir,
  gerando,
  imprimirGraficos,
  mostrarResumo,
  mostrarGraficos,
  mostrarSugestoes,
  listar_resumo_teste,
  dadosSugestoes,
  todosSelecionados,
  propriedade,
  nome_equipamento,
  realizado_por,
  nome_consultor,
}) => {
  const { consultoria, nameCliente } = useAccess()
  const logo_cliente = localStorage.getItem('logo')

  const listRef = useRef(null)

  const sentido11 = listar_resumo_teste?.calculo.filter((item) => item?.sentido === 11)
  const sentido12 = listar_resumo_teste?.calculo.filter((item) => item?.sentido === 12)
  const sentidosResumos = dividirEmPaginasResumoSumario(listar_resumo_teste?.calculo, 'resumo')

  const scrollToIndex = () => {
    const list = listRef.current
    const scrollElement = list?.outerRef || list?._outerRef // fallback para versões antigas

    if (scrollElement) {
      scrollElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }
  
  const Row = ({ index, style, data }) => {
    return (
      <Render condition={imprimirGraficos === false}>
        <div style={style}>
          <div key={index} className='pagina__a4__window'>
            <HeaderRelatorio>
              <div
                className='campo__taxa__cv'
                style={{
                  backgroundColor: verificarCvCoresGraficos(data[index]?.grupo[0]?.cv)[0]
                    ?.backGround,
                  border: `2px solid ${
                    verificarCvCoresGraficos(data[index]?.grupo[0]?.cv)[0]?.border
                  }`,
                  color: verificarCvCoresGraficos(data[index].grupo[0]?.cv)[0]?.color,
                }}
              >
                {`CV: ${data[index].grupo[0]?.cv} - Taxa média: ${data[index].grupo[0]?.media} kg/ha`}
              </div>

              <div className='campo__faixa'>
                <p
                  style={{ margin: 0, padding: 0 }}
                >{`Faixa de aplicação - ${data[index].grupo[0]?.largura}`}</p>
              </div>
            </HeaderRelatorio>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <p style={{ margin: 0, padding: 0 }}>
                {data[index].grupo[0]?.sentido === 11
                  ? 'Sentidos de aplicação (Vai e vai)'
                  : 'Sentidos opostos de aplicação (Vai e vem)'}
              </p>
            </div>
            <Tratores>
              <div className='container__tratores'>
                <div className='trator__direito'>
                  <img style={{ width: '70px', height: '70px' }} src={Trator} />
                  <FontAwesomeIcon className='seta' fontSize={20} icon={faLongArrowAltUp} />
                </div>
                <div className='trator__esquerdo'>
                  <FontAwesomeIcon
                    className='seta'
                    style={{ rotate: data[index].grupo[0]?.sentido === 12 ? '180deg' : 'none' }}
                    fontSize={20}
                    icon={faLongArrowAltUp}
                  />
                  <img
                    style={{
                      width: '70px',
                      height: '70px',
                      rotate: data[index].grupo[0]?.sentido === 12 ? '180deg' : 'none',
                    }}
                    src={Trator}
                  />
                </div>
              </div>
            </Tratores>

            <img src={data[index]?.grafico11} />

            <HeaderRelatorio>
              <div
                className='campo__taxa__cv'
                style={{
                  backgroundColor: verificarCvCoresGraficos(data[index]?.grupo[1]?.cv)[0]
                    ?.backGround,
                  border: `2px solid ${
                    verificarCvCoresGraficos(data[index]?.grupo[1]?.cv)[0]?.border
                  }`,
                  color: verificarCvCoresGraficos(data[index]?.grupo[1]?.cv)[0]?.color,
                }}
              >
                {`CV: ${data[index]?.grupo[1]?.cv} - Taxa média: ${data[index]?.grupo[1]?.media} kg/ha`}
              </div>

              <div className='campo__faixa'>
                <p
                  style={{ margin: 0, padding: 0 }}
                >{`Faixa de aplicação - ${data[index]?.grupo[1]?.largura}`}</p>
              </div>
            </HeaderRelatorio>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <p style={{ margin: 0, padding: 0 }}>
                {data[index]?.grupo[1]?.sentido === 11
                  ? 'Sentidos de aplicação (Vai e vai)'
                  : 'Sentidos opostos de aplicação (Vai e vem)'}
              </p>
            </div>
            <Tratores>
              <div className='container__tratores'>
                <div className='trator__direito'>
                  <img style={{ width: '70px', height: '70px' }} src={Trator} />
                  <FontAwesomeIcon className='seta' fontSize={20} icon={faLongArrowAltUp} />
                </div>
                <div className='trator__esquerdo'>
                  <FontAwesomeIcon className='seta' fontSize={20} icon={faLongArrowAltUp} />
                  <img
                    style={{
                      width: '70px',
                      height: '70px',
                    }}
                    src={Trator}
                  />
                </div>
              </div>
            </Tratores>

            <img src={data[index]?.grafico12} />

            <Render condition={!esconderSwitch}>
              <Switcher
                label={'Selecionar gráfico'}
                isChecked={graficoSelecionados.includes(data[index]?.cod)}
                trigger={(checked) => graficosSelecionadosImprimir(checked, data[index]?.cod)}
                disabled={gerando}
              />
            </Render>
            <Render condition={esconderSwitch}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img style={{ width: '150px', height: '70px' }} src={Logo}></img>
              </div>
            </Render>
          </div>
        </div>
      </Render>
    )
  }

  return (
    <div>
      <Render condition={!renderizarGraficos}>
        <Render condition={imprimirGraficos === false}>
          <List
            height={700}
            itemCount={dadosFinalizados.length}
            itemSize={1215}
            width='100%'
            itemData={dadosFinalizados}
            ref={listRef}
            outerRef={React.createRef()}
          >
            {Row}
          </List>
        </Render>
        <ButtonCustom
          onClick={scrollToIndex}
          icon={<FontAwesomeIcon icon={faLongArrowAltUp} />}
          style={{ position: 'absolute', top: 'calc( 100vh - 240px )', right: 10 }}
        />
        <Render condition={imprimirGraficos}>
          <Capa className='break' id='topo-documento'>
            <div className='title__primary'>
              <div className='lines'>
                <h1>
                  <span style={{ color: '#01ACB9', fontWeight: 700, fontSize: '50px' }}>
                    RELATÓRIO
                  </span>
                  <span
                    style={{
                      color: '#01ACB9',
                      fontSize: '50px',
                      marginLeft: '10px',
                      fontWeight: 500,
                    }}
                  >
                    TESTE DE
                  </span>{' '}
                  <span style={{ color: '#162B42', fontWeight: 700, fontSize: '50px' }}>
                    BANDEJA
                  </span>
                </h1>
              </div>
            </div>
            <div className='title'>
              <h2 style={{ fontSize: '25px' }}>{propriedade}</h2>
              <span style={{ fontSize: '17px' }}>{nameCliente}</span>
            </div>
            <div className='footer'>
              <img
                className='Capa__logo'
                src={logo_cliente ?? consultoria?.logo_url}
                alt={consultoria?.logo_url ? 'logo-consultoria' : 'consultoria-logo'}
              />
            </div>
          </Capa>
          <SubCapa>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                textAlign: 'center',
                gap: '10px',
              }}
            >
              <div style={{ height: '250px', paddingTop: '40px' }}>
                <img src={Logo} alt='logo' style={{ width: '300px', height: '124px' }} />
              </div>

              <div
                style={{
                  height: '400px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h1 style={{ fontWeight: 600, color: '#01ACB9', fontSize: '36px' }}>
                  {propriedade}
                </h1>
                <h2 style={{ color: '#007c85', fontSize: '26px', fontWeight: 600 }}>
                  {nameCliente}
                </h2>
              </div>

              <div
                style={{
                  height: '300px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '5px',
                  alignItems: 'start',
                  paddingLeft: '60px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                  <h3 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 600 }}>
                    Equipamento:
                  </h3>
                  <h2 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 500 }}>
                    {nome_equipamento}
                  </h2>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                  <h3 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 600 }}>
                    Realizado por:{' '}
                  </h3>
                  <h2 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 500 }}>
                    {realizado_por}
                  </h2>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                  <h3 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 600 }}>Data: </h3>
                  <h2 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 500 }}>
                    {dayjs(listar_resumo_teste?.data).format('DD/MM/YYYY')}
                  </h2>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                  <h3 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 600 }}>
                    Consultor responsável:
                  </h3>
                  <h2 style={{ color: '#6b6c6f', fontSize: '16px', fontWeight: 500 }}>
                    {nome_consultor}
                  </h2>
                </div>
              </div>
            </div>
          </SubCapa>
          <Sumario>
            <span className='Sumario__referencia'>
              <h2 style={{ fontWeight: 700 }}>Sumário</h2>
              <ul key={uniqueId()} className='ul-secundaria'>
                <>
                  <div
                    style={{
                      marginBottom: '10px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '5px',
                    }}
                  >
                    <Fragment>
                      <li className='li-secundaria'>
                        <div className='div-secundaria'>
                          <div
                            style={{
                              display: 'flex',
                              gap: '5px',
                              width: '10%',
                              alignItems: 'center',
                            }}
                          >
                            <a style={{ display: 'flex', gap: 5, fontSize: 13 }}>
                              <strong>Resumo</strong>
                            </a>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'end',
                              justifyContent: 'center',
                              fontWeight: 700,
                            }}
                          >
                            4
                          </div>
                        </div>
                      </li>
                    </Fragment>
                    {sentidosResumos.map((pagina, index) => {
                      return (
                        <Fragment key={index}>
                          <li className='li-secundaria'>
                            <div className='div-secundaria'>
                              {index === 0 ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    gap: '5px',
                                    width: '41%',
                                    alignItems: 'center',
                                    marginLeft: '5px',
                                  }}
                                >
                                  <a style={{ display: 'flex', gap: 5, fontSize: 13 }}>
                                    <span>Sentidos opostos de aplicação (Vai e vem)</span>
                                  </a>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: 'flex',
                                    gap: '5px',
                                    width: '37%',
                                    alignItems: 'center',
                                    marginLeft: '5px',
                                  }}
                                >
                                  <a style={{ display: 'flex', gap: 5, fontSize: 13 }}>
                                    <span>Mesmo sentido de aplicação (Vai e vai)</span>
                                  </a>
                                </div>
                              )}

                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'end',
                                  justifyContent: 'center',
                                }}
                              >
                                {index + 4}
                              </div>
                            </div>
                          </li>
                        </Fragment>
                      )
                    })}
                  </div>

                  <Fragment>
                    <li className='li-secundaria'>
                      <div className='div-secundaria'>
                        <div
                          style={{
                            display: 'flex',
                            gap: '5px',
                            width: '9%',
                            alignItems: 'center',
                          }}
                        >
                          <a style={{ display: 'flex', gap: 5, fontSize: 13 }}>
                            <strong>Gráficos</strong>
                          </a>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'end',
                            justifyContent: 'center',
                            fontWeight: 700,
                          }}
                        >
                          6
                        </div>
                      </div>
                    </li>
                  </Fragment>
                </>
                <div
                  style={{
                    marginBottom: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    marginLeft: '5px',
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Larguras:</span>
                  {dadosFinalizados?.map((item, index) => {
                    return (
                      <Fragment key={item?.cod}>
                        <li className='li-secundaria' id={`${index}`}>
                          <div className='div-secundaria'>
                            <div
                              style={{
                                display: 'flex',
                                gap: '5px',
                                width: '7%',
                                alignItems: 'center',
                                marginLeft: '10px',
                              }}
                            >
                              <a
                                style={{ display: 'flex', gap: 5 }}
                              >{`${item?.grupo[0]?.largura} m`}</a>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'end',
                                justifyContent: 'center',
                              }}
                            >
                              {index + 6}
                            </div>
                          </div>
                        </li>
                      </Fragment>
                    )
                  })}
                </div>
                <Fragment>
                  <li className='li-secundaria'>
                    <div className='div-secundaria'>
                      <div
                        style={{
                          display: 'flex',
                          gap: '5px',
                          width: '10%',
                          alignItems: 'center',
                        }}
                      >
                        <a style={{ display: 'flex', gap: 5, fontSize: 13 }}>
                          <strong>Sugestões</strong>
                        </a>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'end',
                          justifyContent: 'center',
                          fontWeight: 700,
                        }}
                      >
                        28
                      </div>
                    </div>
                  </li>
                </Fragment>
              </ul>
            </span>
          </Sumario>
        </Render>
        <Render condition={mostrarResumo && imprimirGraficos}>
          {dividirEmPaginasResumoSumario(sentido12, 'resumo').map((pagina, index) => (
            <ResumoTesteBandeja key={index}>
              <div className='div-table'>
                {index === 0 && (
                  <div className='titulo__resumo__imprimir'>
                    <h3> Sentidos opostos de aplicação (Vai e vem)</h3>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <FontAwesomeIcon className='seta' fontSize={13} icon={faLongArrowAltUp} />
                      <FontAwesomeIcon
                        className='seta'
                        fontSize={13}
                        style={{ rotate: '180deg' }}
                        icon={faLongArrowAltUp}
                      />
                    </div>
                  </div>
                )}
                <table>
                  <thead>
                    <tr>
                      <th>Largura</th>
                      <th>CV%</th>
                      <th>Mínimo(kg/ha)</th>
                      <th>Máxima(kg/ha)</th>
                      <th>Média(kg/ha)</th>

                      {/* <th>Unidade</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {pagina
                      .filter((rec) => rec?.sentido === 12)
                      .map((rec) => {
                        return (
                          <TrReverse key={rec?.cod}>
                            <th>{`${rec?.largura} m`}</th>
                            <td>
                              <div style={{ height: '10px' }}>
                                <Tag
                                  style={{
                                    backgroundColor: verificarCvCoresGraficos(rec?.cv)[0]
                                      ?.backGround,
                                    border: `2px solid ${
                                      verificarCvCoresGraficos(rec?.cv)[0]?.border
                                    }`,
                                    color: verificarCvCoresGraficos(rec?.cv)[0]?.color,
                                  }}
                                >
                                  {rec?.cv}
                                </Tag>
                              </div>
                            </td>
                            <td>
                              <div>{rec?.minima} </div>
                            </td>
                            <td>
                              <div>{rec?.maxima} </div>
                            </td>
                            <td>
                              <div>{rec?.media} </div>
                            </td>
                          </TrReverse>
                        )
                      })}
                  </tbody>
                </table>
              </div>
              <Render condition={esconderSwitch}>
                <div className='rodape'>
                  <div className='gradiente' />

                  <div className='logo'>
                    <span style={{ fontWeight: '700', marginLeft: '10px', fontSize: 13 }}>
                      ttivos® gestão rural
                    </span>
                  </div>
                  <small className='texto'>Licenciado para: {consultoria?.linha1}</small>
                </div>
                <Page>{4}</Page>
              </Render>
            </ResumoTesteBandeja>
          ))}
          {dividirEmPaginasResumoSumario(sentido11, 'resumo').map((pagina, index) => (
            <ResumoTesteBandeja key={index}>
              <div className='div-table'>
                {index === 0 && (
                  <div className='titulo__resumo__imprimir'>
                    <h3> Mesmo sentido de aplicação (Vai e vai)</h3>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <FontAwesomeIcon className='seta' fontSize={13} icon={faLongArrowAltUp} />
                      <FontAwesomeIcon className='seta' fontSize={13} icon={faLongArrowAltUp} />
                    </div>
                  </div>
                )}
                <table>
                  <thead>
                    <tr>
                      <th>Largura</th>
                      <th>CV%</th>
                      <th>Mínimo(kg/ha)</th>
                      <th>Máxima(kg/ha)</th>
                      <th>Média(kg/ha)</th>
                      {/* <th>Unidade</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {pagina
                      .filter((rec) => rec?.sentido === 11)
                      .map((rec) => {
                        return (
                          <TrReverse key={rec?.cod}>
                            <th>{`${rec?.largura} m`}</th>
                            <td>
                              <div style={{ height: '10px' }}>
                                <Tag
                                  style={{
                                    backgroundColor: verificarCvCoresGraficos(rec?.cv)[0]
                                      ?.backGround,
                                    border: `2px solid ${
                                      verificarCvCoresGraficos(rec?.cv)[0]?.border
                                    }`,
                                    color: verificarCvCoresGraficos(rec?.cv)[0]?.color,
                                  }}
                                >
                                  {rec?.cv}
                                </Tag>
                              </div>
                            </td>
                            <td>
                              <div>{rec?.minima} </div>
                            </td>
                            <td>
                              <div>{rec?.maxima} </div>
                            </td>
                            <td>
                              <div>{rec?.media} </div>
                            </td>
                          </TrReverse>
                        )
                      })}
                  </tbody>
                </table>
              </div>
              <Render condition={esconderSwitch}>
                <div className='rodape'>
                  <div className='gradiente' />

                  <div className='logo'>
                    <span style={{ fontWeight: '700', marginLeft: '10px', fontSize: 13 }}>
                      ttivos® gestão rural
                    </span>
                  </div>
                  <small className='texto'>Licenciado para: {consultoria?.linha1}</small>
                </div>
                <Page>{5}</Page>
              </Render>
            </ResumoTesteBandeja>
          ))}
        </Render>
        <Render condition={mostrarGraficos}>
          {dadosFinalizados.map((item, index) => {
            return (
              <div
                className='teste_'
                key={index}
                data-view={mostrarEsconderGraficos(
                  esconderSwitch,
                  graficoSelecionados,
                  item?.cod,
                  todosSelecionados
                )}
              >
                <div className='pagina-a4'>
                  <HeaderRelatorio>
                    <div
                      className='campo__taxa__cv'
                      style={{
                        backgroundColor: verificarCvCoresGraficos(item?.grupo[0]?.cv)[0]
                          ?.backGround,
                        border: `2px solid ${
                          verificarCvCoresGraficos(item?.grupo[0]?.cv)[0]?.border
                        }`,
                        color: verificarCvCoresGraficos(item.grupo[0]?.cv)[0]?.color,
                      }}
                    >
                      {`CV: ${item.grupo[0]?.cv} - Taxa média: ${item.grupo[0]?.media} kg/ha`}
                    </div>

                    <div className='campo__faixa'>
                      <p
                        style={{ margin: 0, padding: 0 }}
                      >{`Faixa de aplicação - ${item.grupo[0]?.largura}`}</p>
                    </div>
                  </HeaderRelatorio>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <p style={{ margin: 0, padding: 0 }}>
                      {item.grupo[0]?.sentido === 11
                        ? 'Sentidos de aplicação (Vai e vai)'
                        : 'Sentidos opostos de aplicação (Vai e vem)'}
                    </p>
                  </div>
                  <Tratores>
                    <div className='container__tratores'>
                      <div className='trator__direito'>
                        <img style={{ width: '70px', height: '70px' }} src={Trator} />
                        <FontAwesomeIcon className='seta' fontSize={20} icon={faLongArrowAltUp} />
                      </div>
                      <div className='trator__esquerdo'>
                        <FontAwesomeIcon
                          className='seta'
                          style={{ rotate: item.grupo[0]?.sentido === 12 ? '180deg' : 'none' }}
                          fontSize={20}
                          icon={faLongArrowAltUp}
                        />
                        <img
                          style={{
                            width: '70px',
                            height: '70px',
                            rotate: item.grupo[0]?.sentido === 12 ? '180deg' : 'none',
                          }}
                          src={Trator}
                        />
                      </div>
                    </div>
                  </Tratores>

                  <img className='teste__bar' src={item?.grafico11} />

                  <HeaderRelatorio>
                    <div
                      className='campo__taxa__cv'
                      style={{
                        backgroundColor: verificarCvCoresGraficos(item?.grupo[1]?.cv)[0]
                          ?.backGround,
                        border: `2px solid ${
                          verificarCvCoresGraficos(item?.grupo[1]?.cv)[0]?.border
                        }`,
                        color: verificarCvCoresGraficos(item?.grupo[1]?.cv)[0]?.color,
                      }}
                    >
                      {`CV: ${item?.grupo[1]?.cv} - Taxa média: ${item?.grupo[1]?.media} kg/ha`}
                    </div>

                    <div className='campo__faixa'>
                      <p
                        style={{ margin: 0, padding: 0 }}
                      >{`Faixa de aplicação - ${item?.grupo[1]?.largura}`}</p>
                    </div>
                  </HeaderRelatorio>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <p style={{ margin: 0, padding: 0 }}>
                      {item?.grupo[1]?.sentido === 11
                        ? 'Sentidos de aplicação (Vai e vai)'
                        : 'Sentidos opostos de aplicação (Vai e vem)'}
                    </p>
                  </div>
                  <Tratores>
                    <div className='container__tratores'>
                      <div className='trator__direito'>
                        <img style={{ width: '70px', height: '70px' }} src={Trator} />
                        <FontAwesomeIcon className='seta' fontSize={20} icon={faLongArrowAltUp} />
                      </div>
                      <div className='trator__esquerdo'>
                        <FontAwesomeIcon className='seta' fontSize={20} icon={faLongArrowAltUp} />
                        <img
                          style={{
                            width: '70px',
                            height: '70px',
                          }}
                          src={Trator}
                        />
                      </div>
                    </div>
                  </Tratores>

                  <img className='teste__bar' src={item?.grafico12} />

                  <Render condition={!esconderSwitch}>
                    <Switcher
                      label={'Selecionar gráfico'}
                      isChecked={graficoSelecionados.includes(item?.cod)}
                      trigger={(checked) => graficosSelecionadosImprimir(checked, item?.cod)}
                      disabled={gerando}
                    />
                  </Render>
                </div>
                <Render condition={esconderSwitch}>
                  <div className='rodape'>
                    <div className='gradiente' />

                    <div className='logo'>
                      <span style={{ fontWeight: '700', marginLeft: '10px', fontSize: 13 }}>
                        ttivos® gestão rural
                      </span>
                    </div>
                    <small className='texto'>Licenciado para: {consultoria?.linha1}</small>
                  </div>
                  <Page>{index + 6}</Page>
                </Render>
              </div>
            )
          })}
        </Render>

        <Render condition={mostrarSugestoes && imprimirGraficos}>
          <div
            style={{
              width: '210mm',
              height: '297mm',
              gap: '10px',
              padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <h2 style={{ fontWeight: '600' }}>Sugestões</h2>
            <Box padding={'20px'} style={{ gap: '0px', width: '100%' }}>
              {dadosSugestoes?.map((item, index) => {
                return (
                  <div key={index}>
                    <label style={{ fontWeight: '700' }}>{item?.titulo}</label>
                    <p>{item?.descricao}</p>
                  </div>
                )
              })}
            </Box>
            <Render condition={esconderSwitch}>
              <div className='rodape'>
                <div className='gradiente' />

                <div className='logo'>
                  <span style={{ fontWeight: '700', marginLeft: '10px', fontSize: 13 }}>
                    ttivos® gestão rural
                  </span>
                </div>
                <small className='texto'>Licenciado para: {consultoria?.linha1}</small>
              </div>
              <Page>{28}</Page>
            </Render>
          </div>
        </Render>
      </Render>
    </div>
  )
}
